export function validateCompanyInfo({values}) {
    const errors = {};

    if (!values.name) {
        errors.name = 'profile:error.companyInfo.name';
    }

    if (!values.businessRole) {
        errors.businessRole = 'profile:error.companyInfo.businessRole';
    }

    return errors;
}

export function validateCompanyAddressInfo({values, companyValues}) {
    const errors = {};

    if (!values.address) {
        errors.address = 'profile:error.companyInfo.address';
    }

    if (!values.house) {
        errors.address = 'profile:error.companyInfo.house';
    }

    if (!values.street) {
        errors.address = 'profile:error.companyInfo.street';
    }

    if (!values.city) {
        errors.city = 'profile:error.companyInfo.city';
    }

    if (!values.state) {
        errors.state = 'profile:error.companyInfo.state';
    }

    if (!values.postalCode) {
        errors.postalCode = 'profile:error.companyInfo.postalCode';
    }

    if (!values.country) {
        errors.country = 'profile:error.companyInfo.country';
    }

    return errors;
}
